import { render, staticRenderFns } from "./ServerUsageDetails.vue?vue&type=template&id=51eca436&scoped=true&"
import script from "./ServerUsageDetails.vue?vue&type=script&lang=js&"
export * from "./ServerUsageDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServerUsageDetails.vue?vue&type=style&index=0&id=51eca436&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eca436",
  null
  
)

export default component.exports